import React, { useEffect, useRef, useState } from 'react';
import {
  Grid,
  TextField,
  Button,
  Stack,
  CircularProgress,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useUpdateEffect } from 'react-use';

const VerifiedField = (props) => {
  const {
    checking,
    checkedItem,
    checkedSend,
    checkedAuth,
    setError,
    setState,
    user,
    state,
    name,
    label,
    defaultValue,
    error,
    onBlur,
    onChange,
    onConfirm,
    onCheck,
    onSend,
  } = props;
  const inputRef = useRef();
  const [verified, setVerified] = useState(false);
  const [certCode, setCert] = useState('');

  const handleChange = (event) => {
    const { value: v } = event.target;
    let value = v;
    if (name === 'tel') {
      value = v.replace(/[^\d]/g, '');
      inputRef.current.value = value;
    }
    onChange({ target: { name, value } });
  };

  const handleInputClick = () => {
    if (verified) {
      setVerified(!verified);
      setState({ ...state, [name]: '' });
      inputRef.current.value = '';
    }
  };

  const handleSendClick = () => {
    onSend({ [name]: state[name] });
  };

  const handleCheckClick = () => {
    const type = name;
    let value;
    if (name === 'email') {
      if (!state.email || error.email) {
        setError({
          ...error,
          email: !state.email ? '유효한 메일 형식이 아닙니다.' : error.email,
        });
        return;
      }
      value = state.email.trim();
    }

    if (name === 'tel') {
      if (!state.tel || error.tel) {
        setError({
          ...error,
          tel: !state.tel ? '유효한 전화번호 형식이 아닙니다.' : error.tel,
        });
        return;
      }
      value = state.tel.trim();
    }
    onCheck({ type, value });
  };

  const handleCertChange = (event) => {
    const { value } = event.target;
    setCert(value.replace(/[^\d]/g, ''));
  };

  const handleCertClick = () => {
    onConfirm({ code: certCode, value: { [name]: state[name] } });
  };

  useEffect(() => {
    if (user) {
      setVerified(user.verified[name] || false);
    } else {
      setVerified(null);
    }
  }, [user]);

  useUpdateEffect(() => setVerified(checkedAuth), [checkedAuth]);

  return (
    <Grid container item xs={6} rowSpacing={1}>
      <Grid item xs={12}>
        <TextField
          {...{
            name,
            label,
            defaultValue,
            onChange: handleChange,
            onBlur,
            error: !checkedAuth && !!error[name],
            helperText: !checkedAuth && error[name],
            required: true,
            fullWidth: true,
            variant: 'outlined',
          }}
          onClick={handleInputClick}
          InputProps={{
            endAdornment: (checkedAuth || checkedItem) && verified && (
              <CheckIcon />
            ),
          }}
          disabled={checkedSend || checkedAuth || verified}
          inputRef={inputRef}
        />
      </Grid>
      <Grid item xs={12} sx={{ alignSelf: 'center' }}>
        {!verified && !checkedSend && !checkedItem && (
          <Button
            variant="contained"
            color="secondary"
            onClick={handleCheckClick}
            disabled={
              checkedItem ||
              !!error[name] ||
              (inputRef.current && !inputRef.current.value)
            }
            fullWidth
          >
            중복 확인
          </Button>
        )}
        {!verified && checkedItem && !checkedSend && (
          <Button
            color="secondary"
            variant="contained"
            onClick={handleSendClick}
            disabled={!checkedItem}
            fullWidth
          >
            {checking.send ? (
              <CircularProgress
                size="small"
                sx={{ width: '24px', height: '24px' }}
              />
            ) : (
              `${name === 'email' ? '이메일' : '문자'} 전송`
            )}
          </Button>
        )}
        {!verified &&
          checkedSend &&
          !checkedAuth &&
          inputRef.current &&
          inputRef.current.value && (
            <Stack direction="row" alignItems="center">
              <TextField
                name="cert"
                variant="outlined"
                label="인증번호"
                error={!!error.auth}
                helperText={error.auth}
                onChange={handleCertChange}
                sx={{ mr: 1 }}
                fullWidth
              />
              <Button
                color="secondary"
                variant="contained"
                disabled={certCode.length !== 5}
                onClick={handleCertClick}
              >
                확인
              </Button>
            </Stack>
          )}
      </Grid>
      {!verified &&
        checkedSend &&
        !checkedAuth &&
        inputRef.current &&
        inputRef.current.value && (
          <Grid item xs={12} sx={{ alignSelf: 'center' }}>
            <Button
              color="secondary"
              variant="contained"
              onClick={handleSendClick}
              disabled={!checkedItem}
              fullWidth
            >
              {checking.send ? (
                <CircularProgress
                  size="small"
                  sx={{ width: '24px', height: '24px' }}
                />
              ) : (
                `${name === 'email' ? '이메일' : '문자'} 재전송`
              )}
            </Button>
          </Grid>
        )}
    </Grid>
  );
};

export default VerifiedField;
